'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require('./utils');

var slideOutRight = {
  from: {
    transform: (0, _utils.translate3d)(0, 0, 0)
  },
  to: {
    visibility: 'hidden',
    transform: (0, _utils.translate3d)('100%', 0, 0)
  }
};
exports.default = slideOutRight;


//////////////////
// WEBPACK FOOTER
// ./~/react-animations/lib/slide-out-right.js
// module id = 261
// module chunks = 54990529738226 257444579329143